import MuiVisibilityOff from '@mui/icons-material/VisibilityOff';

export const VisibilityOffIcon = () => <MuiVisibilityOff />;
